var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.field._label)?_c('label',{staticClass:"label",class:{'label_error':!!_vm.validator.failed},attrs:{"for":_vm.name},domProps:{"innerHTML":_vm._s(_vm.field._label)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }